import React, { Component } from 'react';
import { slide as ReactMobileMenu } from 'react-burger-menu';

import { MenuItemAnchor, MenuItemLink } from '../MenuItem/MenuItem';

import './MobileMenu.css';

class MobileMenu extends Component {
  constructor() {
    super();
    this.handleCLickItem = this.handleCLickItem.bind(this);
  }
  state = {
    isOpen: false,
  };

  handleCLickItem(text = '') {
    this.setState({ isOpen: false });
    this.props.onClickMenu(text);
  }
  render() {
    return (
      <ReactMobileMenu right isOpen={this.state.isOpen}>
        <MenuItemAnchor
          className="brasserie"
          text="Brasserie"
          anchor="#la-brasserie"
          onClick={() => this.handleCLickItem('Brasserie')}
        />
        <MenuItemAnchor
          className="lesbieres"
          text="Bières"
          anchor="#les-bieres"
          onClick={() => this.handleCLickItem('Bières')}
        />
        <MenuItemAnchor
          className="pointsdevente"
          text="Points de vente"
          anchor="#les-points-de-vente"
          onClick={() => this.handleCLickItem('Points de vente')}
        />
        <MenuItemAnchor
          className="contact"
          text="Contact"
          anchor="#contact"
          onClick={() => this.handleCLickItem('Contact')}
        />
        <MenuItemLink
          className="playlist"
          text="Playlist"
          onClick={this.handleCLickItem}
        />
        <MenuItemLink
          className="facebook"
          text="Facebook"
          url="https://www.facebook.com/BIERESLEBAIGNEUR/"
          onClick={this.handleCLickItem}
        />
        <MenuItemLink
          className="instagram"
          text="Instagram"
          url="https://www.instagram.com/brasseriedubaigneur/"
          onClick={this.handleCLickItem}
        />
      </ReactMobileMenu>
    );
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/Components/MobileMenu/MobileMenu.js